import { useTranslation } from 'react-i18next';
import { FormAction } from '@anytag/shared-types';
import { TextareaField } from '@anytag/shared-molecules';
import { BaseModal, BaseModalProps, Form, ModalBody, ModalFooter } from '@anytag/shared-atoms';

export interface ConfirmDenyingInfluencerFormValues {
  reason: string;
}

export interface ConfirmDenyingInfluencerModalProps extends Omit<BaseModalProps, 'footer'> {
  loading?: boolean;
  onSubmit?: FormAction<ConfirmDenyingInfluencerFormValues>['onSubmit'];
}

export const ConfirmDenyingInfluencerModal = ({
  onClose,
  loading,
  onSubmit,
  ...restProps
}: ConfirmDenyingInfluencerModalProps) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      onClose={onClose}
      title={t('Dialog.Deny This Influencer')}
      description={t('Dialog.Deny Influencer Explained')}
      {...restProps}
      asChild
    >
      <Form.Provider<ConfirmDenyingInfluencerFormValues> onSubmit={onSubmit}>
        {({ values }) => (
          <>
            <ModalBody>
              <TextareaField<keyof ConfirmDenyingInfluencerFormValues>
                name="reason"
                placeholder={t<string>('JobDescription.Contents Placeholder')}
                title={t('TextForm.Reasons for Denial')}
                required
              />
            </ModalBody>

            <ModalFooter
              cancelButton={{ onClick: onClose }}
              submitButton={{
                type: 'submit',
                title: t('Button.Deny'),
                disabled: !values.reason,
                loading: { showIcon: true, status: loading }
              }}
            />
          </>
        )}
      </Form.Provider>
    </BaseModal>
  );
};
